"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledComboboxInput = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _ComboboxInputMixin = require("../../mixins/components/ComboboxInputMixin");
var StyledComboboxInput = /*#__PURE__*/_styledComponents.default.div.withConfig({
  displayName: "StyledComboboxInput",
  componentId: "c11n-8-107-0__sc-78pewz-0"
})(["", ""], _ComboboxInputMixin.ComboboxInputMixin);
exports.StyledComboboxInput = StyledComboboxInput;